export const purchaseColumns = [
  { field: "bookingId", headerName: "Booking ID", width: 240 },
  { field: "item", headerName: "Item", width: 327 },
  { field: "type", headerName: "Type", width: 150 },
  { field: "quantity", headerName: "Quantity", width: 130 },
  { field: "selectedLocation", headerName: "Selected Location", width: 200 },
  { field: "amount", headerName: "Amount", width: 150 },
  { field: "bookingDate", headerName: "Booking Date", width: 180 }
];
